
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { useAppContext } from "../../context/AppContext"; // Adjust path if needed
import AppStoreButton from "./AppStoreButton";



// --- Helper Component 2: LocationDisplay ---
const LocationDisplay = () => {
  const { state } = useLocation();
  const { location: contextLocation } = useAppContext(); 
    const location = state?.location || contextLocation;
 return (
    <div className="flex items-center gap-3 text-white">
      <div className="relative flex items-center justify-center w-10 h-10 border border-white/30 rounded-full">
        <motion.div
          animate={{ scale: [1, 1.5, 1], opacity: [0.5, 0, 0.5] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute w-full h-full bg-white/20 rounded-full"
        />
        <MapPin size={16} />
      </div>
      <div className="flex flex-col">
        <span className="text-[10px] uppercase tracking-widest opacity-60">
          Current Location
        </span>
        <span className="font-bold text-sm">
          {location?.city && location.city !== "Locating..."
            ? `${location.city}, ${location.pincode}`
            : "Unavailable"}
        </span>
      </div>
    </div>
  );
};

// --- Helper Component 3: The Main Links Section ---
const MainFooterLinks = () => {
  const linkClasses =
    "text-gray-400 hover:text-white transition-colors duration-200 text-sm";
  const headingClasses =
    "text-md font-bold text-white mb-6 tracking-widest uppercase";

  return (
    <div className="py-20 border-t border-white/10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div className="md:col-span-1">
          <h4 className={headingClasses}>Get the App</h4>
          <p className="text-gray-400 text-sm mb-6">
            Manage your organizations, appointments, and services on the go.
          </p>
          <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row gap-4">
            <AppStoreButton
              platform="Apple"
              href="https://apple.com/app-store"
            />
            <AppStoreButton platform="Google" href="https://play.google.com" />
          </div>
        </div>
        <div className="md:col-span-2 grid grid-cols-2 sm:grid-cols-3 gap-8">
          <div>
            <h4 className={headingClasses}>Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className={linkClasses}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className={linkClasses}>
                  Careers
                </Link>
              </li>
              {/* NOTE: Corrected link to /blog to match your router */}
              <li>
                <Link to="/news" className={linkClasses}>
                  News
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className={headingClasses}>Partners</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/partners" className={linkClasses}>
                  Partner With Us
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className={headingClasses}>Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className={linkClasses}>
                  Terms
                </Link>
              </li>
              <li>
                <Link to="/privacy" className={linkClasses}>
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/refunds" className={linkClasses}>
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- The Main Exported Footer Component ---
const AppFooter = () => {
  return (
    <footer>
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-20">
        <MainFooterLinks />
        <div className="py-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <LocationDisplay />
          <div className="text-center md:text-right text-xs text-gray-600 uppercase tracking-widest">
            {/* NOTE: Using XENFORD as requested for the overall brand */}
            &copy; {new Date().getFullYear()} XENFORD. ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
